import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisV } from '@fortawesome/pro-solid-svg-icons';

import { listItemPropTypes, reorderableListItem } from 'helpers/react_dnd/reorderable_list';

export class ChecklistItemRow extends React.Component {
  static propTypes = {
    ...listItemPropTypes,
    checklistItem: PropTypes.shape({
      id: PropTypes.number,
      listingType: PropTypes.string,
      projectStatus: PropTypes.string,
      sortOrder: PropTypes.number,
      taskTitle: PropTypes.string
    }).isRequired,
    clickAction: PropTypes.func.isRequired,
    index: PropTypes.number.isRequired,
    listName: PropTypes.string.isRequired,
    targetGroup: PropTypes.string.isRequired
  };

  render() {
    const style = {
      opacity: this.props.isDragging ? 0 : 1,
    };

    return this.props.connectDragPreview(this.props.connectDropTarget(this.props.connectDragSource(
      <li
        className="list-group-item clickable d-flex align-items-center"
        index={this.props.index}
        key={this.props.index}
        name="item-row"
        style={style}
        onClick={this.props.clickAction}
      >
        <FontAwesomeIcon className="me-3 text-muted my-0" icon={faEllipsisV} />
        {this.props.checklistItem.taskTitle}
      </li>
    )));
  }
}

export default reorderableListItem(ChecklistItemRow, 'checklistItemRow', {
  canDrag: () => true,
  beginDrag(props) {
    return {
      id: props.id,
      index: props.index,
      listName: props.listName,
      originalIndex: props.index,
      targetGroup: props.targetGroup
    };
  }
});
